import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class PVModuleModel {
  id: number;
  manufacturer: string;
  type: string;
  count: number;
  modulePowerWatt: number;
}

export type PVModuleForm = TypedForm<PVModuleModel>;
